export default {
    buttons: {
        back: 'Trang trước',
        home: 'Trở về trang chủ',
    },
};
